import { makeStyles } from 'tss-react/mui';

interface SearchFieldStylesParams {
  isCollapsed: boolean;
}

export const useSearchFieldStyles = makeStyles<SearchFieldStylesParams>()(
  (theme, { isCollapsed }) => ({
    root: {
      flexShrink: 0,
      maxWidth: '100%',
      minWidth: 0,
      alignItems: 'center',
      gap: theme.spacing(0.5),
      color: theme.palette.accent.light,
    },
    sizer: {
      fontFamily: theme.typography.body1.fontFamily,
      fontSize: theme.typography.body1.fontSize,
      fontWeight: theme.typography.body1.fontWeight,
      lineHeight: theme.typography.body1.lineHeight,
      letterSpacing: theme.typography.body1.letterSpacing,
      display: 'inline-grid',
      minWidth: 0,
      maxWidth: '100%',
      overflow: 'hidden',
      ...(isCollapsed && { width: 0 }),
      '&:focus-within': { width: 'auto' },
      '&::after': {
        content: 'attr(data-value)',
        gridArea: '1 / 1',
        visibility: 'hidden',
        whiteSpace: 'pre',
        font: 'inherit',
        letterSpacing: 'inherit',
      },
      '& .MuiInputBase-root': {
        gridArea: '1 / 1',
        width: '100%',
        minWidth: 0,
        font: 'inherit',
        letterSpacing: 'inherit',
      },
      '& .MuiInputBase-input': {
        padding: 0,
        minWidth: 0,
        font: 'inherit',
        letterSpacing: 'inherit',
      },
    },
    input: {
      color: theme.palette.text.primary,
    },
    clearButton: {
      display: 'inline-flex',
      cursor: 'pointer',
    },
  }),
);
